import React from "react"
import styles from "./blockTextImgUp.module.css"
const BlockTextImgUp = ({ bgColor, data }) => {
  const {
    title,
    text,
    img: {
      uri: { url: image },
    },
  } = data
  return (
    <section className={styles.blockTextImgUp}>
      <div className={styles.blockTextImgUp__text}>
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
      <div className={styles.blockTextImgUp__img}>
        <img src={`https://drupal.smartempo.com/${image}`} alt={title} />
      </div>
    </section>
  )
}
export default BlockTextImgUp
